import { PaymentModeCodes } from '@payment/const';
import { IconTypes } from '@shared/v2';

export const PaymentModesIcons = {
  [PaymentModeCodes.Sbrf]: IconTypes.CARD,
  [PaymentModeCodes.CashCardReceive]: IconTypes.CARD,
  [PaymentModeCodes.CashCardShop]: IconTypes.SHOP,
  [PaymentModeCodes.CardDelivery]: IconTypes.CARD,
  [PaymentModeCodes.CashDelivery]: IconTypes.RUBLE,
  [PaymentModeCodes.Sbp]: IconTypes.SBP,
  [PaymentModeCodes.Plait]: IconTypes.PLAIT,
  [PaymentModeCodes.QrDelivery]: IconTypes.QR,
} as const;

export type PaymentModesIcons = (typeof PaymentModesIcons)[keyof typeof PaymentModesIcons];
